import rules from "./Common/RbacRules";
import { authContext } from '../../Utils/AdalConfig';

export function CheckAuthorization(action, data) { return check(action, data) }

//Operations and Operations Admin profiles: admin:view is granted only to them in RbacRules, so the profile ids live in one place
export function isOperationsUser() {
    return check('admin:view');
}

//Email editor (Stripo): Operations always, Voucher Admin only when the hotel group has the EmailDesigner module (checked on the server too)
export function canUseEmailDesigner() {
    return check('emailTemplates:design') && (isOperationsUser() || !!global.modules?.includes('EmailDesigner'));
}

//AI features (template assistant today, others later): the hotel group needs the AiFeatures module (checked on the server too)
export function canUseAi() {
    return !!global.modules?.includes('AiFeatures');
}

//Hotel group has the Voucher (pdf) designer module; alone it only shows the "My Templates" tab
export function hasPdfDesignerModule() {
    return !!global.modules?.includes('VoucherDesigner');
}

//Voucher (pdf) designer: voucherTemplates:design and the hotel group needs the VoucherDesigner module, for every profile (Operations included)
export function canUsePdfDesigner() {
    return check('voucherTemplates:design') && hasPdfDesignerModule();
}

const check = (action, data) => {

    if (authContext.getCachedUser().profile == undefined || authContext.getCachedUser().profile.groups === undefined) return false;
    let max = authContext.getCachedUser().profile.groups.length;
    for (var fieldIndex = 0; fieldIndex <= max; fieldIndex++) {

        const permissions = rules[authContext.getCachedUser().profile.groups[fieldIndex]];

        if (permissions) {
            const staticPermissions = permissions.static;

            if (staticPermissions && staticPermissions.includes(action)) {
                // static rule not provided for action
                return true;
            }

            if (staticPermissions && staticPermissions.includes(action)) {
                // static rule not provided for action
                return true;
            }
        }

        if (permissions) {
            const dynamicPermissions = permissions.dynamic;

            if (dynamicPermissions) {
                const permissionCondition = dynamicPermissions[action];
                if (!permissionCondition) {
                    // dynamic rule not provided for action
                    return false;
                }

                return permissionCondition(data);
            }
        }
    }
     
    //if (!permissions) {
        // role is not present in the rules
    //    return false;
    //}

    
    return false;
};

const Authorization = props =>
    check( props.perform, props.data)
        ? props.yes()
        : props.no();

Authorization.defaultProps = {
    yes: () => null,
    no: () => null
};

export default Authorization;